"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseXcon = parseXcon;
const xml_js_1 = require("xml-js");
function parseXcon(content) {
    const root = (0, xml_js_1.xml2js)(content, { compact: false, addParent: false });
    const schemaEl = findChild(root, 'schema');
    if (schemaEl === null) {
        throw new Error('xcon: missing <schema> root element');
    }
    const headerEl = findChild(schemaEl, 'header');
    const designsEl = findChild(schemaEl, 'designs');
    const schemaVersion = textOf(findChild(headerEl, 'schemaVersion'));
    const creatorTool = textOf(findChild(headerEl, 'creatorTool'));
    const savedLibrary = textOf(findChild(headerEl, 'savedLibrary'));
    const designs = (designsEl?.elements ?? [])
        .filter((el) => el.type === 'element' && el.name === 'design')
        .map(parseDesign);
    return { schemaVersion, creatorTool, savedLibrary, designs };
}
function parseDesign(designEl) {
    const cells = new Map();
    for (const cellEl of childrenNamed(findChild(designEl, 'cells'), 'cell')) {
        const cell = parseCell(cellEl);
        cells.set(cell.id, cell);
    }
    const nets = new Map();
    for (const netEl of childrenNamed(findChild(designEl, 'nets'), 'net')) {
        const net = parseNet(netEl);
        nets.set(net.id, net);
    }
    const instances = new Map();
    for (const instEl of childrenNamed(findChild(designEl, 'instances'), 'instance')) {
        const instance = parseInstance(instEl);
        instances.set(instance.id, instance);
    }
    return {
        name: attrOf(designEl, 'name'),
        view: attrOf(designEl, 'view'),
        cells,
        nets,
        instances,
    };
}
function parseCell(cellEl) {
    const terms = childrenNamed(findChild(cellEl, 'terms'), 'term').map((termEl) => ({
        id: textOf(findChild(termEl, 'id')),
        name: textOf(findChild(termEl, 'name')),
        direction: textOf(findChild(termEl, 'direction')),
    }));
    return {
        id: textOf(findChild(cellEl, 'id')),
        library: textOf(findChild(cellEl, 'library')),
        name: textOf(findChild(cellEl, 'name')),
        view: textOf(findChild(cellEl, 'view')),
        terms,
    };
}
function parseNet(netEl) {
    return {
        id: textOf(findChild(netEl, 'id')),
        name: textOf(findChild(netEl, 'name')),
        scope: textOf(findChild(netEl, 'scope')),
        direction: textOf(findChild(netEl, 'direction')),
    };
}
function parseInstance(instEl) {
    const parameters = childrenNamed(findChild(instEl, 'parameters'), 'parameter').map((paramEl) => ({
        name: textOf(findChild(paramEl, 'name')),
        value: textOf(findChild(paramEl, 'value')),
    }));
    const pins = childrenNamed(findChild(instEl, 'pins'), 'pin').map(parsePin);
    return {
        id: textOf(findChild(instEl, 'id')),
        cellId: textOf(findChild(instEl, 'cellid')),
        name: textOf(findChild(instEl, 'name')),
        parameters,
        pins,
    };
}
function parsePin(pinEl) {
    const netIds = [];
    for (const conn of childrenNamed(findChild(pinEl, 'connections'), 'connection')) {
        const netAttr = attrOf(conn, 'net');
        if (netAttr.length > 0) {
            netIds.push(netAttr);
        }
    }
    return {
        id: textOf(findChild(pinEl, 'id')),
        termId: textOf(findChild(pinEl, 'termid')),
        netIds,
    };
}
function findChild(parent, name) {
    if (parent === null || parent.elements === undefined) {
        return null;
    }
    for (const el of parent.elements) {
        if (el.type === 'element' && el.name === name) {
            return el;
        }
    }
    return null;
}
function childrenNamed(parent, name) {
    if (parent === null || parent.elements === undefined) {
        return [];
    }
    return parent.elements.filter((el) => el.type === 'element' && el.name === name);
}
function textOf(el) {
    if (el === null || el.elements === undefined) {
        return '';
    }
    let out = '';
    for (const child of el.elements) {
        if (child.type === 'text' && typeof child.text === 'string') {
            out += child.text;
        }
        else if (child.type === 'cdata' && typeof child.cdata === 'string') {
            out += child.cdata;
        }
    }
    return out;
}
function attrOf(el, name) {
    const attrs = el.attributes;
    if (attrs === undefined) {
        return '';
    }
    const v = attrs[name];
    return typeof v === 'string' ? v : '';
}
//# sourceMappingURL=xconParser.js.map